import React from "react";
import { Image } from "antd";
import { imageUrl } from "./constant";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Carousel.css";

// Swiper css
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

const Carousel = () => {
  return (
    <>
      <Swiper
        pagination={{
          clickable: true,
        }}
        id="carousel"
        navigation={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        modules={[Pagination, Navigation, Autoplay]}
      >
        {imageUrl.map((image, i) => (
          <SwiperSlide key={i}>
            <Image
              preview={false}
              src={image}
              alt={`Slide ${i + 1}`}
              className="img-responsive"
              width={"100%"}
              height={"100%"}
              style={{ objectFit: "contain" }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default Carousel;
